export default {
    slug: 'assistants',
    ability: 'assistants',
    routes: [
        {
            path: 'anomalies',
            name: 'anomalies',
            component: () => import('@modules/Assistants/Resources/js/pages/anomalies/List.vue'),
            // What the list asks for as it opens, in one request (utils/listBootstrap.js).
            meta: { listBootstrap: { list: 'anomalies' } },
            children: [
                {
                    path: ':id(\\d+)',
                    name: 'anomaly-preview',
                    component: () => import('@modules/Assistants/Resources/js/pages/anomalies/Preview.vue'),
                    redirect: { name: 'anomaly-overview' },
                    props: true,
                    children: [
                        {
                            path: '/organization/:org/anomalies/:id(\\d+)',
                            name: 'anomaly-overview',
                            component: () =>
                                import('@modules/Assistants/Resources/js/pages/anomalies/preview/Overview.vue'),
                            props: true
                        },
                        {
                            path: 'logs',
                            name: 'anomaly-logs',
                            component: () => import('@/components/base/tabs/TabLogs.vue'),
                            props: route => ({ id: route.params.id, entityType: 'anomaly' })
                        }
                    ]
                }
            ]
        }
    ],
    nav: () => ({
        section: 'accounting',
        items: [
            {
                title: i18n.t('Monitoring'),
                icon: 'shield-search',
                // No filter seeded: the list opens on everything, here as
                // everywhere else. A search the user did not type is a search
                // they have to notice before they can trust the count.
                //
                // Nothing is lost by it — the default sort is `last_seen_at`
                // descending, and only live findings get their sighting
                // refreshed by each scan, so what is still standing floats to
                // the top on its own.
                to: { name: 'anomalies' }
            }
        ]
    })
};
